import type { SVGProps } from 'react';

import type { JSX } from 'react';

export function Chevron({
  ...props
}: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 12"
      {...props}
    >
      <path
        fill="#452B5D"
        d="M1.887 12 .5 10.517 4.726 6 .5 1.483 1.887 0 7.5 6l-5.613 6Z"
      />
    </svg>
  );
}
